import React from 'react'
import eRecht24_Privacy from 'assets/images/erecht24-privacy.png';
import store from 'stores/store'
import styles from './PrivacyPolicy.module.scss'

const PrivacyPolicy = () => {
  return (
    <div className={styles.wrapper}>

      <section className={styles.row}>
        <div>
          <h1 className={styles.header}>
            Datenschutzerklärung
          </h1>
          <p className={styles.update}>
          </p>
        </div>
      </section>

      {/* Privacy Policy Text */}
      <section className={styles.content}>
        {store.privacy.content}
      </section>

    </div>
  )
}

export { PrivacyPolicy as default }